import React, { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "../context/AuthContext";
import { GoogleButton } from "../components/GoogleButton";

export const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const { signIn, signInWithGoogle } = useAuth();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const redirect = searchParams.get("redirect") || "/conta";

  const submit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    const { error } = await signIn(email, password);
    setSubmitting(false);
    if (error) {
      toast.error("Credenciais inválidas", { description: "Verifica o e-mail e a palavra-passe." });
      return;
    }
    navigate(redirect);
  };

  const handleGoogle = async () => {
    const { error } = await signInWithGoogle(redirect);
    if (error) toast.error("Erro ao iniciar sessão com Google", { description: error.message });
  };

  return (
    <div className="container-da py-16 max-w-md mx-auto" data-testid="login-page">
      <p className="font-script text-[var(--da-leaf)] text-2xl text-center">olá de novo</p>
      <h1 className="text-3xl sm:text-4xl text-center mt-1">Iniciar sessão</h1>

      <div className="mt-8">
        <GoogleButton onClick={handleGoogle} testid="login-google" />
      </div>

      <div className="flex items-center gap-3 my-6">
        <div className="flex-1 h-px bg-[var(--da-line)]" />
        <span className="font-body text-xs uppercase tracking-[0.2em] text-[var(--da-muted)]">ou</span>
        <div className="flex-1 h-px bg-[var(--da-line)]" />
      </div>

      <form onSubmit={submit} className="space-y-4" data-testid="login-form">
        <label className="block">
          <span className="font-body text-xs uppercase tracking-[0.18em] text-[var(--da-forest)]">E-mail</span>
          <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} data-testid="login-email" className="mt-2 w-full bg-white border hairline rounded-lg px-4 py-3 font-body text-sm focus:outline-none focus:border-[var(--da-leaf)]" />
        </label>
        <label className="block">
          <span className="font-body text-xs uppercase tracking-[0.18em] text-[var(--da-forest)]">Palavra-passe</span>
          <input type="password" required value={password} onChange={(e) => setPassword(e.target.value)} data-testid="login-password" className="mt-2 w-full bg-white border hairline rounded-lg px-4 py-3 font-body text-sm focus:outline-none focus:border-[var(--da-leaf)]" />
          <div className="text-right mt-1">
            <Link to="/conta/esqueceu-senha" className="font-body text-xs text-[var(--da-muted)] hover:text-[var(--da-forest)] underline">
              Esqueceste a palavra-passe?
            </Link>
          </div>
        </label>
        <button type="submit" disabled={submitting} className="btn-da btn-da-primary w-full disabled:opacity-60" data-testid="login-submit">
          {submitting ? "A entrar…" : "Entrar"}
        </button>
      </form>

      <p className="font-body text-sm text-[var(--da-muted)] text-center mt-6">
        Ainda não tens conta? <Link to="/conta/registar" className="text-[var(--da-forest)] underline" data-testid="login-go-register">Criar conta</Link>
      </p>
    </div>
  );
};
